import { schema } from 'normalizr'

import * as schemas from './individual.schema'

export const notesSchema = new schema.Entity('notes', {
    PTEVAL: [schemas.PTEVAL],
    PTNOTE: [schemas.PTNOTE],
    PTOBJECTIVETEMPLATESXREF: [schemas.PTOBJECTIVETEMPLATESXREF],
    PTOBJECTIVEASTERISKS: [schemas.PTOBJECTIVEASTERISKS],
    PTOBJECTIVEOBS: [schemas.PTOBJECTIVEOBS],
    PTOBJECTIVEACCJOINTMOB: [schemas.PTOBJECTIVEACCJOINTMOB],
    PTOBJECTIVEPALP: [schemas.PTOBJECTIVEPALP],
    PTOBJECTIVEROM: [schemas.PTOBJECTIVEROM],
    PTOBJECTIVESTR: [schemas.PTOBJECTIVESTR],
    PTOBJECTIVESPECTESTS: [schemas.PTOBJECTIVESPECTESTS],
    PTOUTMEASURES: [schemas.PTOUTMEASURES],
    PTOBJECTIVEPEDS: [schemas.PTOBJECTIVEPEDS],
    PTOBJECTIVEPEDSMUSCU: [schemas.PTOBJECTIVEPEDSMUSCU],
    PTOBJECTIVEPEDSTONE: [schemas.PTOBJECTIVEPEDSTONE],
    PTOBJECTIVESPEECH: [schemas.PTOBJECTIVESPEECH],
    PTGOALS: [schemas.PTGOALS],
    PTSHORTGOALS: [schemas.PTSHORTGOALS],
    PTASSESSMENT: [schemas.PTASSESSMENT],
    PTASSESSMENTFLAGS: [schemas.PTASSESSMENTFLAGS],
    PTPLAN: [schemas.PTPLAN],
    PTPLANTIMEDMODALITIES: [schemas.PTPLANTIMEDMODALITIES],
    PTPLANUNTIMEDMODALITIES: [schemas.PTPLANUNTIMEDMODALITIES],
    PTPLANUNTIMEDOTHER: [schemas.PTPLANUNTIMEDOTHER],
    PTADDENDUM: [schemas.PTADDENDUM],
    PTNOTEAUDIT: [schemas.PTNOTEAUDIT],
    PTSCRIBELOG: [schemas.PTSCRIBELOG],
    MLEXLOG: [schemas.MLEXLOG],
    MLAQUATICS: [schemas.MLAQUATICS],
    MLEVAL: [schemas.MLEVAL],
    MLFCEPOET: [schemas.MLFCEPOET],
    MLGAIT: [schemas.MLGAIT],
    MLMANUAL: [schemas.MLMANUAL],
    MLMODALITIES: [schemas.MLMODALITIES],
    MLNEURO: [schemas.MLNEURO],
    MLOTHER: [schemas.MLOTHER],
    MLPHYSRECOND: [schemas.MLPHYSRECOND],
    MLSELFCARE: [schemas.MLSELFCARE],
    MLSPECIALTYTESTS: [schemas.MLSPECIALTYTESTS],
    MLSPEECH: [schemas.MLSPEECH],
    MLWORKPROG: [schemas.MLWORKPROG],
    MLTHERACT: [schemas.MLTHERACT],
    MLTHEREX: [schemas.MLTHEREX],
    MLWORKHARD: [schemas.MLWORKHARD],
    CWPAINSCREENING: [schemas.CWPAINSCREENING],
    PTEVALPEDS: [schemas.PTEVALPEDS],
    CPEPISODE: [schemas.CPEPISODE],
    PTOBJECTIVETEMPLATES: [schemas.PTOBJECTIVETEMPLATES],
    PTOBJECTIVETEMPLATEPANELXREF: [schemas.PTOBJECTIVETEMPLATEPANELXREF],
    FOTOPATIENTRESPONSE: [schemas.FOTOPATIENTRESPONSE],
    EVALCODES: [schemas.EVALCODES],
    MLTEMPLATE: [schemas.MLTEMPLATE],
    PTGOALTEMPLATE: [schemas.PTGOALTEMPLATE],
    PTGOALTEMPLATEDETAILS: [schemas.PTGOALTEMPLATEDETAILS],
    PTOBJECTIVEMATHAND: [schemas.PTOBJECTIVEMATHAND],
    PTOBJECTIVENONMATHAND: [schemas.PTOBJECTIVENONMATHAND],
    WPALTEMPLATE: [schemas.WPALTEMPLATE],
    WPALTEMPLATEHEADERS: [schemas.WPALTEMPLATEHEADERS],
    WPALTEMPLATEITEMS: [schemas.WPALTEMPLATEITEMS],
    MLTMPAQUATICS: [schemas.MLTMPAQUATICS],
    MLTMPGAIT: [schemas.MLTMPGAIT],
    MLTMPMANUAL: [schemas.MLTMPMANUAL],
    MLTMPMODALITIES: [schemas.MLTMPMODALITIES],
    MLTMPNEURO: [schemas.MLTMPNEURO],
    MLTMPOTHER: [schemas.MLTMPOTHER],
    MLTMPPHYSRECOND: [schemas.MLTMPPHYSRECOND],
    MLTMPSELFCARE: [schemas.MLTMPSELFCARE],
    MLTMPSPECIALTYTESTS: [schemas.MLTMPSPECIALTYTESTS],
    MLTMPTHERACT: [schemas.MLTMPTHERACT],
    MLTMPTHEREX: [schemas.MLTMPTHEREX],
    PTGOALFAVORITES: [schemas.PTGOALFAVORITES],
    SUPV: [schemas.SUPV],
    MLCHARGEREQUESTS: [schemas.MLCHARGEREQUESTS],
    MLCOMPUTEDCHARGES: [schemas.MLCOMPUTEDCHARGES],
    PTNOTEUPDATES: [schemas.PTNOTEUPDATES],
    PTSUBJECTIVE: [schemas.PTSUBJECTIVE],
    PTSUBJECTIVEPREV: [schemas.PTSUBJECTIVEPREV],
    PTEVALSUBJECTIVE: [schemas.PTEVALSUBJECTIVE],
    MLAQUATICSPREV: [schemas.MLAQUATICSPREV],
    MLGAITPREV: [schemas.MLGAITPREV],
    MLMANUALPREV: [schemas.MLMANUALPREV],
    MLMODALITIESPREV: [schemas.MLMODALITIESPREV],
    MLNEUROPREV: [schemas.MLNEUROPREV],
    MLOTHERPREV: [schemas.MLOTHERPREV],
    MLSELFCAREPREV: [schemas.MLSELFCAREPREV],
    MLSPECIALTYTESTSPREV: [schemas.MLSPECIALTYTESTSPREV],
    MLSPEECHPREV: [schemas.MLSPEECHPREV],
    MLTHERACTPREV: [schemas.MLTHERACTPREV],
    MLTHEREXPREV: [schemas.MLTHEREXPREV],
    PTASSESSMENTPREV: [schemas.PTASSESSMENTPREV],
    PTPAINPREV: [schemas.PTPAINPREV],
    PTOBJECTIVEROMPREV: [schemas.PTOBJECTIVEROMPREV],
    PTOBJECTIVESTRPREV: [schemas.PTOBJECTIVESTRPREV],
    PTOBJECTIVENONMATHANDPREV: [schemas.PTOBJECTIVENONMATHANDPREV],
    PTOBJECTIVEMATHANDPREV: [schemas.PTOBJECTIVEMATHANDPREV],
    NoteWarnings: [schemas.NoteWarnings],
    CILIST: [schemas.CILIST],
    STUDENTLIST: [schemas.STUDENTLIST],
    PLANYEARS: [schemas.PLANYEARS],
    CHARGES: [schemas.CHARGES],
    NOTEMETADATA: [schemas.NOTEMETADATA]

});
